import { memo } from 'react';
import { CustomTheme } from '../../theme/customTheme';

type Props = {
  size?: number;
  color?: string;
};

function TruckIcon({ size = 50, color = CustomTheme.colors.contentPrimary }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      zoomAndPan="magnify"
      viewBox="0 0 810 809.999993"
      height={size}
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="f9fd39b1eb">
          <path
            d="M 295 126 L 516 126 L 516 299 L 295 299 Z M 295 126 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="d201918c1d">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="6976e0c2d9">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="233925ebb5">
          <path
            d="M 316 132 L 352 132 L 352 151 L 316 151 Z M 316 132 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="35467634d6">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="2930139005">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="3a21cb7d2c">
          <path
            d="M 460 133 L 496 133 L 496 152 L 460 152 Z M 460 133 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="54d1c151d2">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="2e0663cc23">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="9160939c61">
          <path
            d="M 441 160 L 451 160 L 451 193 L 441 193 Z M 441 160 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="e4849f4c33">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="b3684e573b">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="1c400089e5">
          <path
            d="M 361 159 L 371 159 L 371 192 L 361 192 Z M 361 159 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="121a918ca8">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="42b97d82f3">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="6cf107f095">
          <path
            d="M 282 302 L 526 302 L 526 644 L 282 644 Z M 282 302 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="a43077216d">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="85f191c453">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="1f4d57dfa0">
          <path
            d="M 295 317 L 515 317 L 515 366 L 295 366 Z M 295 317 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="24c7611f19">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="99b3f3a785">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="e0d7c10a34">
          <path
            d="M 294 474 L 514 474 L 514 559 L 294 559 Z M 294 474 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="1f0cd4ce4a">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="6736291ee8">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="75f58d3dcc">
          <path
            d="M 293 570 L 513 570 L 513 629 L 293 629 Z M 293 570 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="422836f9c5">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="03e9d3dd97">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="fd54e6f8b7">
          <path
            d="M 294 378 L 514 378 L 514 463 L 294 463 Z M 294 378 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="369aa91210">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="1455abc700">
          <path
            d="M 407.875 754.566406 L 55.824219 415.183594 L 402.492188 55.574219 L 754.542969 394.953125 Z M 407.875 754.566406 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#f9fd39b1eb)">
        <g clipPath="url(#d201918c1d)">
          <g clipPath="url(#6976e0c2d9)">
            <path
              fill={color}
              d="M 360.359375 155.152344 C 361.992188 154.832031 363.65625 155.304688 364.800781 156.417969 C 365.378906 156.96875 365.792969 157.660156 365.992188 158.414062 L 374.664062 190.929688 C 374.957031 192.046875 374.78125 193.21875 374.15625 194.210938 C 373.472656 195.292969 372.324219 196.0625 371 196.3125 C 369.367188 196.625 367.707031 196.164062 366.5625 195.050781 C 365.988281 194.496094 365.578125 193.808594 365.371094 193.054688 L 356.703125 160.535156 C 356.40625 159.421875 356.582031 158.25 357.207031 157.25 C 357.886719 156.171875 359.035156 155.402344 360.359375 155.152344 Z M 473.691406 212.316406 C 474.441406 212.3125 475.140625 212.679688 475.570312 213.289062 C 476 213.894531 476.105469 214.671875 475.863281 215.375 L 458.980469 264 C 458.652344 264.929688 457.773438 265.5625 456.78125 265.558594 L 353.71875 265.050781 C 353.109375 265.050781 352.542969 264.804688 352.128906 264.40625 C 351.867188 264.152344 351.660156 263.839844 351.542969 263.476562 L 335.238281 214.6875 C 335 213.980469 335.121094 213.203125 335.558594 212.601562 C 335.996094 211.996094 336.695312 211.640625 337.445312 211.648438 Z M 451.453125 155.597656 C 452.382812 155.789062 453.21875 156.21875 453.875 156.851562 C 455.027344 157.960938 455.464844 159.519531 455.046875 161.027344 L 445.992188 193.449219 C 445.34375 195.761719 442.855469 197.171875 440.324219 196.65625 C 439.398438 196.46875 438.5625 196.035156 437.90625 195.402344 C 436.75 194.289062 436.3125 192.726562 436.734375 191.234375 L 445.78125 158.800781 C 446.429688 156.492188 448.921875 155.082031 451.453125 155.597656 Z M 479.347656 236.429688 L 477.671875 293.527344 C 477.640625 294.78125 476.605469 295.78125 475.351562 295.773438 L 460.523438 295.699219 C 459.910156 295.699219 459.351562 295.449219 458.9375 295.050781 C 458.5 294.628906 458.226562 294.03125 458.226562 293.375 L 458.367188 269.449219 C 458.371094 269.15625 458.433594 268.855469 458.546875 268.59375 L 475.117188 228.027344 C 475.347656 227.476562 475.777344 227.0625 476.285156 226.824219 Z M 349.613281 295.152344 L 334.726562 295.078125 C 334.109375 295.082031 333.550781 294.832031 333.136719 294.433594 C 332.707031 294.019531 332.441406 293.449219 332.433594 292.8125 L 331.429688 235.804688 L 331.410156 235.832031 L 334.121094 228.984375 C 334.863281 229.140625 335.515625 229.644531 335.808594 230.390625 L 351.898438 271.109375 C 352.011719 271.382812 352.0625 271.675781 352.058594 271.96875 L 351.9375 292.855469 C 351.933594 293.464844 351.6875 294.050781 351.25 294.488281 C 350.816406 294.917969 350.222656 295.15625 349.613281 295.152344 Z M 348.277344 150.757812 C 343.503906 153.785156 337.222656 155.4375 330.582031 155.402344 C 324.863281 155.375 319.492188 154.09375 315.078125 151.785156 C 315.648438 173.800781 316.207031 197.734375 316.761719 222.257812 C 316.8125 224.367188 316.859375 226.484375 316.910156 228.609375 L 313.582031 236.425781 C 307.730469 239.464844 303.5 241.667969 302.3125 244.800781 L 295.707031 262.265625 C 295.011719 264.109375 295.519531 266.101562 297.074219 267.601562 C 297.910156 268.410156 299.007812 269.015625 300.253906 269.355469 C 304.019531 270.398438 308.183594 268.671875 309.351562 265.589844 L 317.542969 256.976562 C 317.71875 265.03125 317.894531 273.078125 318.066406 281.074219 L 318.4375 297.710938 L 491.675781 298.566406 L 492.140625 284.761719 C 492.445312 275.828125 492.746094 266.839844 493.058594 257.851562 L 491.144531 252.609375 L 501.144531 266.535156 C 501.425781 267.296875 501.882812 267.996094 502.515625 268.605469 C 504.40625 270.425781 507.421875 271.128906 510.203125 270.394531 C 512.164062 269.871094 513.757812 268.6875 514.5625 267.140625 C 515.007812 266.300781 515.40625 264.949219 514.828125 263.34375 L 508.429688 245.816406 C 508.097656 244.90625 507.496094 244.042969 506.597656 243.175781 C 504.574219 241.226562 501.179688 239.414062 497.257812 237.320312 L 495.996094 236.652344 L 494.261719 222.761719 C 495.109375 198.34375 495.945312 174.550781 496.78125 152.632812 C 492.324219 154.929688 486.90625 156.175781 481.140625 156.140625 C 472.828125 156.101562 465.039062 153.359375 460.3125 148.804688 C 457.285156 145.882812 455.691406 142.425781 455.714844 138.792969 C 455.730469 135.605469 457.046875 132.507812 459.496094 129.820312 C 416.566406 125.234375 390.371094 125.042969 352.363281 129.101562 C 354.902344 131.859375 356.238281 135.039062 356.214844 138.308594 C 356.1875 143.101562 353.367188 147.523438 348.277344 150.757812 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#233925ebb5)">
        <g clipPath="url(#35467634d6)">
          <g clipPath="url(#2930139005)">
            <path
              fill={color}
              d="M 316.507812 147.320312 C 320.367188 149.511719 325.390625 150.757812 330.605469 150.78125 C 336.378906 150.8125 341.773438 149.421875 345.804688 146.855469 C 349.519531 144.5 351.574219 141.453125 351.597656 138.289062 C 351.605469 136.460938 350.941406 134.679688 349.617188 132.992188 C 345.21875 133.480469 340.679688 134.019531 335.785156 134.632812 C 326.285156 137.453125 319.398438 142.011719 316.507812 147.320312 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#3a21cb7d2c)">
        <g clipPath="url(#54d1c151d2)">
          <g clipPath="url(#2e0663cc23)">
            <path
              fill={color}
              d="M 463.527344 145.480469 C 467.414062 149.230469 474.011719 151.480469 481.171875 151.519531 C 486.460938 151.546875 491.558594 150.320312 495.453125 148.113281 C 492.75 142.539062 485.800781 137.925781 476.253906 135.332031 C 471.367188 134.746094 466.710938 134.214844 462.234375 133.722656 C 460.980469 135.34375 460.347656 137.054688 460.328125 138.816406 C 460.316406 141.761719 462.058594 144.066406 463.527344 145.480469 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#9160939c61)">
        <g clipPath="url(#e4849f4c33)">
          <g clipPath="url(#b3684e573b)">
            <path
              fill={color}
              d="M 441.574219 192.097656 L 450.503906 160.121094 C 450.335938 160.09375 450.207031 160.136719 450.222656 160.078125 L 441.277344 192.128906 L 441.574219 192.097656 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#1c400089e5)">
        <g clipPath="url(#121a918ca8)">
          <g clipPath="url(#42b97d82f3)">
            <path
              fill={color}
              d="M 370.097656 191.757812 L 361.59375 159.746094 C 361.570312 159.722656 361.472656 159.671875 361.261719 159.707031 L 369.804688 191.75 L 370.097656 191.757812 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#6cf107f095)">
        <g clipPath="url(#a43077216d)">
          <g clipPath="url(#85f191c453)">
            <path
              fill={color}
              d="M 308.871094 313.015625 L 501.0625 313.957031 C 505.660156 313.980469 510.019531 315.75 513.332031 318.941406 C 516.871094 322.355469 518.804688 326.949219 518.777344 331.871094 L 518.558594 368.296875 C 518.558594 369.574219 517.511719 370.601562 516.238281 370.601562 L 293.023438 369.5 C 292.40625 369.5 291.851562 369.25 291.4375 368.851562 C 290.996094 368.433594 290.722656 367.835938 290.726562 367.179688 L 290.945312 330.746094 C 291.003906 320.925781 299.046875 312.96875 308.871094 313.015625 Z M 518.507812 377.21875 L 517.988281 464.535156 C 517.980469 465.8125 516.941406 466.839844 515.664062 466.832031 L 292.445312 465.734375 C 291.851562 465.738281 291.28125 465.503906 290.851562 465.09375 L 290.820312 465.054688 C 290.390625 464.613281 290.148438 464.03125 290.152344 463.421875 L 290.671875 376.101562 C 290.679688 374.820312 291.722656 373.792969 293 373.800781 L 516.210938 374.902344 C 517.484375 374.90625 518.511719 375.945312 518.507812 377.21875 Z M 517.265625 471.816406 C 517.699219 472.257812 517.9375 472.839844 517.933594 473.460938 L 517.414062 560.769531 C 517.402344 562.046875 516.359375 563.074219 515.085938 563.070312 L 291.875 561.972656 C 291.28125 561.96875 290.714844 561.738281 290.285156 561.328125 L 290.246094 561.289062 C 289.8125 560.855469 289.574219 560.265625 289.578125 559.648438 L 290.097656 472.335938 C 290.109375 471.0625 291.144531 470.03125 292.425781 470.035156 L 515.640625 471.140625 C 516.25 471.136719 516.816406 471.355469 517.265625 471.816406 Z M 516.695312 568.054688 C 517.121094 568.492188 517.367188 569.085938 517.363281 569.695312 L 517.089844 615.042969 C 517.035156 624.871094 508.984375 632.828125 499.160156 632.777344 L 306.96875 631.835938 C 302.367188 631.8125 298.011719 630.046875 294.703125 626.851562 C 291.160156 623.433594 289.230469 618.847656 289.25 613.925781 L 289.527344 568.574219 C 289.53125 567.964844 289.773438 567.378906 290.210938 566.945312 C 290.648438 566.515625 291.238281 566.273438 291.847656 566.277344 L 515.0625 567.375 C 515.675781 567.378906 516.277344 567.617188 516.695312 568.054688 Z M 284.738281 316.878906 L 282.886719 627.730469 C 282.855469 631.792969 284.457031 635.582031 287.382812 638.402344 C 290.113281 641.035156 293.710938 642.496094 297.511719 642.515625 L 508.488281 643.546875 C 512.417969 643.574219 516.125 642.054688 518.917969 639.292969 C 521.714844 636.53125 523.265625 632.839844 523.285156 628.910156 L 525.140625 318.0625 C 525.164062 314 523.574219 310.207031 520.648438 307.386719 C 517.914062 304.753906 514.3125 303.292969 510.511719 303.277344 L 299.542969 302.238281 C 291.425781 302.203125 284.789062 308.769531 284.738281 316.878906 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#1f4d57dfa0)">
        <g clipPath="url(#24c7611f19)">
          <g clipPath="url(#99b3f3a785)">
            <path
              fill={color}
              d="M 295.359375 364.894531 L 513.953125 365.96875 L 514.160156 331.851562 C 514.179688 328.203125 512.746094 324.796875 510.117188 322.273438 C 507.671875 319.910156 504.441406 318.601562 501.035156 318.582031 L 308.835938 317.636719 C 301.558594 317.605469 295.605469 323.496094 295.5625 330.769531 L 295.359375 364.894531 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#e0d7c10a34)">
        <g clipPath="url(#1f0cd4ce4a)">
          <g clipPath="url(#6736291ee8)">
            <path
              fill={color}
              d="M 512.804688 558.4375 L 513.300781 475.742188 L 294.707031 474.667969 L 294.207031 557.363281 L 512.804688 558.4375 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#75f58d3dcc)">
        <g clipPath="url(#422836f9c5)">
          <g clipPath="url(#03e9d3dd97)">
            <path
              fill={color}
              d="M 297.910156 623.527344 C 300.363281 625.890625 303.59375 627.199219 306.996094 627.210938 L 499.191406 628.15625 C 506.472656 628.191406 512.429688 622.300781 512.46875 615.023438 L 512.726562 571.976562 L 294.132812 570.910156 L 293.875 613.949219 C 293.847656 617.59375 295.289062 620.992188 297.910156 623.527344 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clipPath="url(#fd54e6f8b7)">
        <g clipPath="url(#369aa91210)">
          <g clipPath="url(#1455abc700)">
            <path
              fill={color}
              d="M 513.378906 462.203125 L 513.878906 379.507812 L 295.28125 378.433594 L 294.789062 461.125 L 513.378906 462.203125 "
              fillOpacity="1"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default memo(TruckIcon);
